import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "dialog-footer",
  style: {"text-align":"right"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  class: "dialog-footer mt-20",
  style: {"text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mb-10 filter-mark" }, "红色代表出库状态为“待定” 且 采购状态为“无需采购” 或“已入库”物料，蓝色代表出库状态为“待定” 且 采购状态为非“无需采购”且“已入库”物料", -1)),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      border: "",
      style: {"width":"100%"},
      "max-height": "400px",
      "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
      stripe: "",
      "row-class-name": _ctx.tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "采购状态",
          prop: "purchaseStatusValue"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "statusValue"
        }),
        _createVNode(_component_el_table_column, {
          label: "物料名称",
          prop: "name",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.material.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "物料型号",
          prop: "model",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.material.model), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "数量",
          prop: "num",
          "min-width": "80"
        }),
        _createVNode(_component_el_table_column, {
          label: "申请原因",
          prop: "des",
          "min-width": "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "位置",
          prop: "location",
          "min-width": "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.location?.location), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "出库审批人",
          prop: "approveUserName",
          "min-width": "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "出库审批时间",
          prop: "approveTime",
          "min-width": "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "归还审批人",
          prop: "backUserName",
          "min-width": "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "归还审批时间",
          prop: "backTime",
          "min-width": "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createTime",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          label: "物料编号",
          prop: "no",
          "min-width": "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.material.no), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "物料单位",
          prop: "materialUnit",
          "min-width": "80"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.material.materialUnit), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "物料类别",
          prop: "materialClass",
          "min-width": "80",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.material.materialClass), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "materialMark",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.material.mark), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          fixed: "right",
          width: "140"
        }, {
          default: _withCtx(({ row }) => [
            ((row.purchaseStatusValue === '无需采购' || row.purchaseStatusValue === '已入库') && row.statusValue === '待定')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  href: "javascript:void(0);",
                  class: "mr-10",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleCommand('deliver-comfirm', row))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" 出库 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "明细列表",
      width: "70%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode(" 关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.deliverTableData,
          border: "",
          style: {"width":"100%"},
          "max-height": "400px",
          "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
          stripe: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "采购状态",
              prop: "purchaseStatusValue"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              prop: "statusValue"
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              prop: "num",
              "min-width": "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "物料编号",
              prop: "no",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.material.no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "物料名称",
              prop: "name",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.material.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "物料型号",
              prop: "model",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.material.model), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "申请数量",
              prop: "model",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.num), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "物料单位",
              prop: "materialUnit",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.material.materialUnit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              fixed: "right",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                (row.statusValue === '待确认' && !row.locationId)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      href: "javascript:void(0);",
                      class: "mr-10",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.handleCommand('deliver', row))
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" 预出库 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.statusValue === '待确认')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      href: "javascript:void(0);",
                      class: "mr-10",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.handleCommand('delete', row))
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" 删除 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.deliverVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deliverVisible) = $event)),
      title: _ctx.isDeliverComfirm ? '出库' : '预出库',
      width: "70%"
    }, {
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
          _createElementVNode("span", { class: "left" }, "物料信息")
        ], -1)),
        _createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "物料编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料型号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.model), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料单位：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.materialUnit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料类别：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.materialClass), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "数量：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.num), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, {
          ref: "dataForm",
          model: _ctx.ruleForm,
          rules: _ctx.rules,
          "label-position": "top",
          "label-width": "100px",
          class: "mb-20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form_item, {
                label: "数量",
                prop: "num"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.ruleForm.num,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.num) = $event)),
                    type: "number",
                    min: 0,
                    max: _ctx.activeRow.num
                  }, null, 8, ["modelValue", "max"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "位置",
                prop: "locationId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.ruleForm.locationId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.locationId) = $event)),
                    class: "filter-item",
                    placeholder: "输入关键字搜索",
                    clearable: "",
                    size: _ctx.t('table.btnSize')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.locationId,
                          label: item.location?.location,
                          value: item.locationId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "size"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deliverVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDeliverComfirm ? _ctx.handleDeliverComfirm() : _ctx.handleDeliver()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}